import qs from 'qs'

const fields = [
  'title'
]

export const queryCalendarPageTitle = (locale: QueryLocaleString) => {
  const query = qs.stringify(
    {
      locale: locale || 'en-US',
      fields: fields
    },
    {
      encodeValuesOnly: true
    }
  )

  return `calendar-page?${query}`
}
